import {config} from "@/config/config";

var stripe = window.Stripe(config('STRIPE'));
export function FalStripe(){
    return stripe;
}
